export interface ODataParams {
    filter?: string;
    orderby?: string;
    select?: string[];
    expand?: string[];
    top?: number;
    skip?: number;
    count?: boolean;
}

export const buildODataQuery = (params: ODataParams): string => {
    const parts: string[] = [];
    if (params.filter)         parts.push(`$filter=${params.filter}`);
    if (params.orderby)        parts.push(`$orderby=${params.orderby}`);
    if (params.select?.length) parts.push(`$select=${params.select.join(',')}`);
    if (params.expand?.length) parts.push(`$expand=${params.expand.join(',')}`);
    if (params.top !== undefined)  parts.push(`$top=${params.top}`);
    if (params.skip !== undefined) parts.push(`$skip=${params.skip}`);
    if (params.count)          parts.push(`$count=true`);
    return parts.length ? `?${parts.join('&')}` : '';
};
